export const PermissionType = {
    CREATE_NOTE: "CreateNote",
    COMPLETE_TASK: "CompleteTask",
    REJECT_TASK: "RejectTask",
    REJECT_BULK_FQA_TASKS: "RejectBulkFqaTasks",
    EDIT_SOURCE: "EditSource",
    EDIT_DIGITAL_LITE_STATUS: "EditDigitalLiteStatus",
    UPLOAD_SHOT: "UploadShot",
    DELETE_SHOT: "DeleteShot",
    UPLOAD_IMAGE: "UploadImage",
    DOWNLOAD_IMAGE: "DownloadImage",
    UPLOAD_BULK: "UploadBulk",
    DOWNLOAD_BULK: "DownloadBulk",
    PACKAGE_TYPE: "PackageType",
    SKIP_EDITING: "SkipEditing",
    REDO_TASK: "RedoTask",
    MEASURE_PEGHOLES: "MeasurePegholes",
    ADD_ATTRIBUTE: "AddAttribute",
    EDIT_ATTRIBUTE: "EditAttribute",
    DELETE_ATTRIBUTE: "DeleteAttribute",
    COMPLETE_BULK_UPLOAD_IMAGES_FOR_MULTIPLE_UPCS: "CompleteBulkUploadImagesForMultipleUpcs",
};
